import { render, staticRenderFns } from "./wx_set.vue?vue&type=template&id=63cdcc5e&scoped=true&"
import script from "./wx_set.vue?vue&type=script&lang=js&"
export * from "./wx_set.vue?vue&type=script&lang=js&"
import style0 from "./wx_set.vue?vue&type=style&index=0&id=63cdcc5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cdcc5e",
  null
  
)

export default component.exports